export const WEB_PULSE_INTERVAL = 2000;
export const SESSION_STATES = { playing: 'playing', paused: 'paused', loading: 'loading', error: 'error', ready: 'ready' };
export const DEFAULT_ERROR = "Something went wrong, please try again later";
export const DISCONNECTED_TOAST_MSG = "Session disconnected";
export const SESSION_COMPLETED_TOAST_MSG = 'Session Completed';